import { SetInstanceOf } from './instanceof';
export function MakeFactory(create, factories, superClass, options = {}) {
    let _superClass = superClass;
    for (let i = factories.length - 1; i >= 0; i--) {
        _superClass = factories[i](_superClass);
    }
    const _class = create(_superClass);
    Object.defineProperty(_class, IS_FACTORY_CLASS, {
        value: true,
    });
    if (typeof options.name === 'string') {
        Object.defineProperty(_class, 'name', {
            configurable: true,
            enumerable: false,
            value: options.name,
            writable: false,
        });
    }
    if (Array.isArray(options.waterMarks)) {
        for (let i = 0, l = options.waterMarks.length; i < l; i++) {
            Object.defineProperty(_class, options.waterMarks[i], {
                value: true,
            });
        }
    }
    if (options.instanceOf !== void 0) {
        SetInstanceOf(options.instanceOf, _class);
    }
    return _class;
}
export function HasFactoryWaterMark(_class, waterMark, direct = true) {
    return (_class[waterMark] === true) && (direct ? _class.hasOwnProperty(waterMark) : true);
}
const IS_FACTORY_CLASS = Symbol('is-factory-class');
export function IsFactoryClass(_class, direct = true) {
    return (_class[IS_FACTORY_CLASS] === true) && (direct ? _class.hasOwnProperty(IS_FACTORY_CLASS) : true);
}
export function SetSuperArgsForFactoryClass(args, superArgs) {
    if (Array.isArray(args[0])) {
        args[0] = superArgs;
        return args;
    }
    else {
        throw new TypeError(`Expected array as argument 0`);
    }
}
export function SetSuperArgsForStandardClass(args, superArgs) {
    for (let i = 0, l = superArgs.length; i < l; i++) {
        args[i] = superArgs[i];
    }
    return args;
}
export function GetSetSuperArgsFunction(isFactoryClass) {
    return isFactoryClass
        ? SetSuperArgsForFactoryClass
        : SetSuperArgsForStandardClass;
}
export class BaseClass {
}
function FactoryA(superClass) {
    return MakeFactory((superClass) => {
        var _a;
        return _a = class A extends superClass {
                constructor(...args) {
                    const [a] = args[0];
                    super(...args);
                    this.a = a;
                }
            },
            _a.staticA = 'static-a',
            _a;
    }, [], superClass);
}
function FactoryB(superClass) {
    return MakeFactory((superClass) => {
        return class B extends superClass {
            constructor(...args) {
                const [b] = args[0];
                super(...args.slice(1));
                this.b = b;
            }
        };
    }, [], superClass);
}
function FactoryC(superClass) {
    function factory(superClass) {
        return class C extends superClass {
            constructor(...args) {
                const [c] = args[0];
                super(...args.slice(1));
                this.c = c;
                console.log(this.a);
            }
        };
    }
    return MakeFactory(factory, [FactoryA, FactoryB], superClass);
}
class D {
    constructor(d1, d2) {
        this.d1 = d1;
        this.d2 = d2;
    }
}
export function testFactoryV2() {
    const A = FactoryA(D);
    const C = FactoryC(D);
    const a = new A(['a'], 1, '2');
    console.log(a);
    const c = new C([null], ['a'], [2], 1, '2');
    console.log(c);
}
//# sourceMappingURL=factory.js.map